import React from 'react';
import { cnMerge } from '../../../utils/utils';

export const Stack = ({ className, children, ...props }) => (
  <div {...props} className={cnMerge('flex flex-col gap-1', className)}>
    {children}
  </div>
);
